import { Record } from 'immutable';

const StudentPaperBasedHomeworkRecord = Record({
  studentId: undefined,
  studentGeneralInfo: undefined,
  isInProduction: undefined,
  studentStatus: undefined,
  homeworkStatus: undefined,
});

class StudentPaperBasedHomework extends StudentPaperBasedHomeworkRecord { }

export default StudentPaperBasedHomework;



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/StudentPaperBasedHomework/model.js